import React, { useState, useEffect } from "react";
import axios from "axios";
import { environment } from "../../environment.js";
import { Button } from "react-bootstrap";
import { Form, Table, Modal } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import "./logisticmanager.css";
import { Link } from "react-router-dom";
import Loader from "../Components/Loader.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import NavbarNew from "../Components/NavbarNew.js";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const LogisticManager = ({ history, match, props }) => {
  const [dap_users, setUsers] = useState([]);
  const [dap_firstName, setFirstName] = useState("");
  const [dap_lastName, setLastName] = useState("");
  const [dap_phone, setPhone] = useState("");
  const [dap_email, setEmail] = useState("");
  const [dap_address, setAddress] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [dap_states, setDapState] = useState([]);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [postcity, setPostCity] = useState("");
  const [poststate, setPostState] = useState("");
  const [loader, setLoader] = useState(true);

  const [lead_executives, setLexecutivedetails] = useState([]);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
  };
  const [executivedetails, setexecutivedetails] = useState({});

  const dap_id = match.params.id;
  useEffect(() => {
    axios
      .post(environment.dap_url + "users/getAllManagers ", {
        filters: {
          userType: "LOGISTIC_MANAGER",
          isDeleted: true,
          isActive: false,
        },
      })
      .then((res) => {
        console.log(res);
        setUsers(res.data.reverse());
        // setLoader(false);
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  }, []);

  const getlogisticManagerDetail = (_id) => {
    axios
      .get(environment.dap_url + "logisticManager/getDetailsById?id=" + _id)
      .then((res) => {
        console.log(res.data);
        setexecutivedetails(res.data);
        console.log("handleShow called");
        handleShow();
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  };

  const deleteHandler = (_id) => {
    // alert(_id);
    // console.log(id);
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.isConfirmed) {
        axios
          .delete(environment.dap_url + "logisticManager/delete?userId=" + _id)
          .then((res) => {
            // console.log(res.data.data);
            MySwal.fire({
              title: <p>Logistic Manager has been successfully deleted!</p>,
              type: "success",
            }).then((result) => {
              setUsers([]);
              axios
                .post(environment.dap_url + "users/getAllManagers ", {
                  filters: { userType: "LOGISTIC_MANAGER" },
                })
                .then((res) => {
                  setUsers(res.data);
                })
                .catch((err) => {});
            });
            //history.push("/customers");
          })

          .catch((err) => {
            MySwal.fire({
              title: (
                <p>
                  {err?.response?.data?.message ||
                    "Logistic Manager deletion failed"}
                </p>
              ),
              type: "error",
            });
          });
      }
    });
  };

  const columns = [
    {
      dataField: "sl.no",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "id",
      text: "Name",
      sort: true,
      formatter: function (_, row, rowIndex, formatExtraData) {
        // console.log(cell);
        return row.userFirstName + " " + row.userLastName;
        // return dataField;
        // return
      },
    },
    // {
    //   dataField: "userLastName",
    //   text: "Last Name",
    //   sort: true,
    // },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "phone",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "state",
      text: "State",
      sort: true,
    },
    {
      dataField: "city",
      text: "City",
      sort: true,
    },
    {
      dataField: "zip",
      text: "Zip Code",
    },
    {
      dataField: "_id",
      text: "Partner",
      sort: true,
      formatter: (dataField, row) => {
        try {
          const parentData =
            row.joinedUsers[0].userFirstName +
            " " +
            row.joinedUsers[0].userLastName;
          return <>{parentData}</>;
        } catch (error) {
          console.log(error);
        }
      },
    },
    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        return (
          <div>
            <Button
              variant="primary"
              className="btn-sm"
              onClick={() => getlogisticManagerDetail(dataField)}
            >
              <i className="fa fa-eye"></i>
            </Button>

            <LinkContainer to={`/logisticmanagers/edit/` + dataField}>
              <Button variant="info" className="btn-sm">
                <i className="fa fa-edit"></i>
              </Button>
            </LinkContainer>
            <Button
              variant="danger"
              className="btn-sm"
              onClick={() => deleteHandler(dataField)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          </div>
        );
      },
    },
    // {
    //   dataField: "_id",
    //   text: "Delete",
    //   sort: false,
    //   formatter: (dataField) => {
    //     return (
    //       <div>
    //         <Button
    //           variant="danger"
    //           className="btn-sm"
    //           onClick={() => deleteHandler(dataField)}
    //         >
    //           Delete <i className="fa fa-trash-o"></i>
    //         </Button>
    //       </div>
    //     );
    //   },
    // },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  return (
    <div>
      <>
        <div className="container-fluid">
          <NavbarNew />
          <h4 className="card-title">LOGISTIC MANAGER</h4>
          <div className="row">
            <div className="col-12">
              <ToolkitProvider
                keyField="id"
                bootstrap4
                data={dap_users}
                columns={columns}
                search
              >
                {(props) => (
                  <div>
                    <div className="d-flex align-items-center">
                      <p className="mb-2 mr-2">Search in table:</p>
                      <SearchBar {...props.searchProps} />
                    </div>
                    <BootstrapTable
                      defaultSorted={defaultSorted}
                      pagination={paginationFactory()}
                      {...props.baseProps}
                      wrapperClasses="table-responsive"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </div>
          </div>
        </div>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {executivedetails.userFirstName +
                " " +
                executivedetails.userLastName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th width="50%" scope="row">
                    Name
                  </th>
                  <td>
                    {executivedetails.userFirstName +
                      " " +
                      executivedetails.userLastName}
                  </td>
                </tr>
                <tr>
                  <th width="50%" scope="row">
                    Email
                  </th>
                  <td>{executivedetails.email}</td>
                </tr>
                <tr>
                  <th width="50%" scope="row">
                    Phone
                  </th>
                  <td>{executivedetails.phone}</td>
                </tr>
                <tr>
                  <th width="50%" scope="row">
                    Country
                  </th>
                  <td>{executivedetails.country}</td>
                </tr>
                <tr>
                  <th width="50%" scope="row">
                    State
                  </th>
                  <td>{executivedetails.state}</td>
                </tr>
                <tr>
                  <th width="50%" scope="row">
                    City
                  </th>
                  <td>{executivedetails.city}</td>
                </tr>
                <tr>
                  <th width="50%" scope="row">
                    Address
                  </th>
                  <td>{executivedetails.address}</td>
                </tr>
                <tr>
                  <th width="50%" scope="row">
                    Zip Code
                  </th>
                  <td>{executivedetails.zip}</td>
                </tr>
                <tr>
                  <th width="50%" scope="row">
                    Created_On
                  </th>
                  <td>{formatDate(executivedetails.createdAt)}</td>
                </tr>
              </tbody>
            </table>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="danger" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    </div>
  );
};

export default LogisticManager;
